import type { Ref } from 'vue';
import { computed } from 'vue';
import { useNuxtApp } from 'nuxt/app';
import { getBlocks, getDocuments, getEanCode, getIsAided, getIsInVirtualStock, getProduct, getProductCategoryId, getProductId, getProductName, getSku, getStockInfos, getVariant, getVariantId } from '~~/common/utils/productData';
import type { ProductData } from '~~/common/stores/product';

export function useProductData ({ productData }: { productData: Ref<ProductData | null | undefined> }) {
  const product = computed(() => getProduct({ productData: productData.value }));
  const variant = computed(() => getVariant(product.value));
  const productId = computed(() => getProductId(product.value));
  const productName = computed(() => getProductName(variant.value));
  const variantId = computed(() => getVariantId(variant.value));
  const eanCode = computed(() => getEanCode(product.value));
  const sku = computed(() => getSku(variant.value));
  const isAided = computed(() => getIsAided(variant.value));
  const isInVirtualStock = computed(() => getIsInVirtualStock(variant.value));
  const blocks = computed(() => getBlocks(product.value, variant.value));
  const productCategoryId = computed(() => getProductCategoryId(product.value));
  const stockInfos = computed(() => getStockInfos(variant.value));
  const documents = computed(() => getDocuments(product.value));
  const priceGrossDiscountedValue = computed(() => {
    return variant.value?.price?.grossDiscounted;
  });
  const creditTypes = computed(() => {
    const creditTypesArr = product.value?.creditTypes;
    return Array.isArray(creditTypesArr) ? creditTypesArr : [];
  });
  const priceGrossDiscountedText = computed(() => {
    const { $price } = useNuxtApp();
    const price = priceGrossDiscountedValue.value;
    const currency = variant.value?.price?.currency;

    return {
      value: price,
      text: $price({ gross: price }, currency ?? ''),
    };
  });
  return {
    product,
    variant,
    productId,
    productName,
    variantId,
    eanCode,
    sku,
    isAided,
    isInVirtualStock,
    blocks,
    productCategoryId,
    stockInfos,
    documents,
    priceGrossDiscountedValue,
    priceGrossDiscountedText,
    creditTypes,
  };
}
